import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sun, Moon, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 shadow-sm">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" onClick={() => window.scrollTo(0, 0)} className="flex items-center">
          <img 
            src="/logo-light.webp" 
            alt="AllSEO Conferences" 
            className="h-20 md:h-36 w-auto dark:hidden"
            data-testid="header-logo-light"
          />
          <img 
            src="/logo-dark.webp" 
            alt="AllSEO Conferences" 
            className="h-20 md:h-36 w-auto hidden dark:block"
            data-testid="header-logo-dark"
          />
        </Link>

        <nav className="hidden md:flex items-center space-x-8">
          <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium transition-colors">
            Home
          </Link>
          <Link to="/blog" className="text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white font-medium transition-colors">
            Blog
          </Link>
          <Link to="/contacts" className="text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white font-medium transition-colors">
            Contacts
          </Link>
        </nav>

        <div className="hidden md:flex items-center space-x-4">
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            aria-label="Toggle theme"
          >
            {darkMode ? (
              <Sun className="w-5 h-5 text-gray-700 dark:text-gray-300" />
            ) : (
              <Moon className="w-5 h-5 text-gray-700" />
            )}
          </button>

          <Link to="/submit">
            <Button className="bg-purple-600 hover:bg-purple-700 text-white">
              Submit Conference
            </Button>
          </Link>
        </div>

        {/* Mobile: Submit button + theme toggle + hamburger */}
        <div className="flex md:hidden items-center space-x-2">
          <Link to="/submit">
            <Button className="bg-purple-600 hover:bg-purple-700 text-white text-sm px-3 py-1 h-9" data-testid="mobile-submit-header-btn">
              Submit Conference
            </Button>
          </Link>
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            aria-label="Toggle theme"
            data-testid="mobile-theme-toggle"
          >
            {darkMode ? (
              <Sun className="w-5 h-5 text-gray-700 dark:text-gray-300" />
            ) : (
              <Moon className="w-5 h-5 text-gray-700" />
            )}
          </button>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? (
              <X className="w-6 h-6 text-gray-700 dark:text-gray-300" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700 dark:text-gray-300" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
          <div className="container mx-auto px-4 py-4 space-y-4">
            <nav className="flex flex-col space-y-3">
              <Link to="/" onClick={() => { setMobileOpen(false); window.scrollTo(0, 0); }} className="text-blue-600 dark:text-blue-400 font-medium py-2" data-testid="mobile-nav-home">
                Home
              </Link>
              <Link to="/blog" onClick={() => setMobileOpen(false)} className="text-gray-700 dark:text-gray-300 font-medium py-2" data-testid="mobile-nav-blog">
                Blog
              </Link>
              <Link to="/contacts" onClick={() => setMobileOpen(false)} className="text-gray-700 dark:text-gray-300 font-medium py-2" data-testid="mobile-nav-contacts">
                Contacts
              </Link>
            </nav>
            <Link to="/submit" onClick={() => setMobileOpen(false)}>
              <Button className="w-full bg-purple-600 hover:bg-purple-700 text-white" data-testid="mobile-submit-btn">
                Submit Conference
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
